import script from "./DropdownComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownComponent.vue?vue&type=script&setup=true&lang=js"

import "./DropdownComponent.vue?vue&type=style&index=0&id=442d5631&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442d5631"]])

export default __exports__